import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import * as styles from './theme.css';

export { vars } from './theme.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'quiet';
  iconOnly?: boolean;
}

export function Button({ variant = 'default', iconOnly = false, className, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        styles.button,
        variant === 'primary' && styles.primaryButton,
        variant === 'quiet' && styles.quietButton,
        iconOnly && styles.iconButton,
        className
      )}
      {...props}
    />
  );
}

export function Panel({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx(styles.panel, className)} {...props} />;
}

export function Eyebrow({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={clsx(styles.eyebrow, className)} {...props} />;
}

export function StatusBadge({ children, className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={clsx(styles.statusBadge, className)} {...props}>{children}</span>;
}

export function Shortcut({ children }: { children: ReactNode }) {
  return <kbd style={{ fontFamily: styles.vars.font.mono, fontSize: 11 }}>{children}</kbd>;
}
